import api from '../index';

const baseUrl = '/appointment';

export const addAppointmentApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create-appointment`,
    data,
  });
};

export const updateAppointmentApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-appointment`,
    data,
  });
};

export const getAppointmentsApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-appointments`,
  });
};

export const getAppointmentApi = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-appointment/${id}`,
  });
};
